<template>
  <div class="thai-hilo-game">
    <div class="thai-hilo-no-bet">
      <thai-hilo-main-bet
        :game="game"
        :game-data="gameData"
        :disallow-betting="disallowBetting"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
      />
      <thai-hilo-bet
        :game="game"
        :game-data="gameData"
        :disallow-betting="disallowBetting"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
      />
      <thai-hilo-number
        :game="game"
        :game-data="gameData"
        :disallow-betting="disallowBetting"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
      />
    </div>

    <div
      ref="thai-hilo-disallow-betting-section"
      class="thai-hilo-disallow-betting-section"
      v-if="displayDisallowSection"
    >
      <Row class="thai-hilo-disallow-betting" type="flex" justify="center" align="middle">
        <Col>
          <div>{{ $t("general.no_more_bet") }}</div>
        </Col>
      </Row>
    </div>

    <div
      ref="animation-section"
      class="thai-hilo-animation-section"
      :class="{ hide: displayStopAnimationSection }"
    >
      <!-- <Row type="flex" justify="center" align="middle" class="thai-hilo-animation">
        <Col>
          <button class="next-draw-button" @click="nextDraw()">Next Draw</button>
        </Col>
      </Row>-->
      <div class="dice-wrapper">
        <div id="perspective" ref="diceOne">
          <div id="animation-dice-1" ref="animation-dice" class="animation-dice">
            <div ref="animation-dice-1-face-1" class="face animation-dice-1-face-1">
              <div class="dot"></div>
            </div>
            <div ref="animation-dice-1-face-2" class="face animation-dice-1-face-2">
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <div ref="animation-dice-1-face-3" class="face animation-dice-1-face-3">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <div ref="animation-dice-1-face-4" class="face animation-dice-1-face-4">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <div ref="animation-dice-1-face-5" class="face animation-dice-1-face-5">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <div ref="animation-dice-1-face-6" class="face animation-dice-1-face-6">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
          </div>
        </div>

        <div id="perspective" ref="diceTwo">
          <div id="animation-dice-2" ref="animation-dice2" class="animation-dice2">
            <div ref="animation-dice-2-face-1" class="face animation-dice-2-face-1">
              <div class="dot"></div>
            </div>
            <div ref="animation-dice-2-face-2" class="face animation-dice-2-face-2">
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <div ref="animation-dice-2-face-3" class="face animation-dice-2-face-3">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <div ref="animation-dice-2-face-4" class="face animation-dice-2-face-4">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <div ref="animation-dice-2-face-5" class="face animation-dice-2-face-5">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <div ref="animation-dice-2-face-6" class="face animation-dice-2-face-6">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
          </div>
        </div>

        <div id="perspective" ref="diceThree">
          <div id="animation-dice-3" ref="animation-dice3" class="animation-dice3">
            <div ref="animation-dice-3-face-1" class="face animation-dice-3-face-1">
              <div class="dot"></div>
            </div>
            <div ref="animation-dice-3-face-2" class="face animation-dice-3-face-2">
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <div ref="animation-dice-3-face-3" class="face animation-dice-3-face-3">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <div ref="animation-dice-3-face-4" class="face animation-dice-3-face-4">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <div ref="animation-dice-3-face-5" class="face animation-dice-3-face-5">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <div ref="animation-dice-3-face-6" class="face animation-dice-3-face-6">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TweenLite, TimelineLite } from "gsap";
import { Row, Button, Timeline } from "iview";
import EventBus from "../../configs/event-bus";
import ThaiHiloMainBet from "./thai-hilo-game/ThaiHiloMainBet";
import ThaiHiloBet from "./thai-hilo-game/ThaiHiloBet";
import ThaiHiloNumber from "./thai-hilo-game/ThaiHiloNumber";

const dice = new TimelineLite();

export default {
  props: [
    "game",
    "gameData",
    "countDown",
    "drawResult",
    "showDrawingAnimation",
    "disallowBetting",
    "displayDisallowSection",
    "minutesString",
    "secondsString",
    "game-on-animation-end"
  ],
  components: {
    ThaiHiloMainBet,
    ThaiHiloBet,
    ThaiHiloNumber,
    Row,
    Button
  },
  data() {
    return {
      isAnimationRunning: false,
      stopAnimation: false,
      displayStopAnimationSection: false,
      dice1: 0,
      dice2: 0,
      dice3: 0
    };
  },
  watch: {
    showDrawingAnimation(newVal, oldVal) {
      if (newVal) {
        this.isAnimationRunning = true;
      }
    },
    drawResult(oldVal, newVal) {
      clearStakeRecord(this.gameData.gID);
      EventBus.$emit("update-session-storage");

      this.$refs["animation-dice"].style.animation =
        "spin 0.5s linear 2s infinite";
      this.$refs["animation-dice2"].style.animation =
        "spin 0.5s linear 2s infinite";
      this.$refs["animation-dice3"].style.animation =
        "spin 0.5s linear 2s infinite";

      this.dice1 = this.drawResult.dice1;
      this.dice2 = this.drawResult.dice2;
      this.dice3 = this.drawResult.dice3;
      let vm = this;
      if (newVal && this.isAnimationRunning == true) {
        let animationTl = new TimelineLite();
        animationTl.set(vm.$refs["animation-section"], {
          display: "flex",
          opacity: 1
        });

        this.diceOneAnimation();
        this.diceTwoAnimation();
        this.diceThreeAnimation();
      }

      let animationTltest = new TimelineLite();
      animationTltest
        .set(vm.$refs["animation-section"], {
          display: "none",
          onComplete: () => {
            TweenLite.set(vm.$refs["diceOne"], { clearProps: "all" });
            TweenLite.set(vm.$refs["diceTwo"], { clearProps: "all" });
            TweenLite.set(vm.$refs["diceThree"], { clearProps: "all" });
            vm.isAnimationRunning = false;
          }
        })
        .delay(8);
    }
  },
  methods: {
    rand() {
      let max = document.getElementsByClassName("thai-hilo-game")[0]
        .clientWidth;
      let temp = Math.random() * (max - 30) + 30;
      return temp - 50;
    },
    diceOneAnimation() {
      let vm = this;

      let animationTl2 = new TimelineLite({
        delay: 1.5,
        onComplete: () => {
          this.$refs["animation-dice"].style.animation = "stop";
          vm.toChangeAnimation(1, vm.dice1);
        }
      });
      animationTl2
        .to(vm.$refs["diceOne"], 0.5, { y: -100 })
        .to(vm.$refs["diceOne"], 1.25, {
          y: 320,
          ease: Bounce.easeOut
        })
        .to(vm.$refs["diceOne"], 2.5, { x: vm.rand() }, "-=1.75")
        .to(vm.$refs["diceOne"], 0.5, { y: 370 }, "-=0.75")
        .to(vm.$refs["diceOne"], 0.5, { y: 150 })
        .to(vm.$refs["diceOne"], 1.25, {
          y: 370,
          ease: Bounce.easeOut
        })
        .to(vm.$refs["diceOne"], 2.5, { x: vm.rand() }, "-=1.75")
        .to(vm.$refs["diceOne"], 0.5, { y: 370 });

      let animationTlStopDice1 = new TimelineLite({
        delay: 5,
        onComplete: () => {
          this.$refs["animation-dice"].style.animation = "stop";
          vm.toChangeAnimation(1, vm.dice1);
        }
      });
    },
    diceTwoAnimation() {
      let vm = this;

      let animationTl3 = new TimelineLite({ delay: 1.5 });
      animationTl3
        .to(vm.$refs["diceTwo"], 0.5, { y: -100 })
        .to(vm.$refs["diceTwo"], 1.25, {
          y: 320,
          ease: Bounce.easeOut
        })
        .to(vm.$refs["diceTwo"], 2.5, { x: vm.rand() }, "-=1.75")
        .to(vm.$refs["diceTwo"], 0.5, { y: 370 }, "-=0.75")
        .to(vm.$refs["diceTwo"], 0.5, { y: 150 })
        .to(vm.$refs["diceTwo"], 1.25, {
          y: 300,
          ease: Bounce.easeOut
        })
        .to(vm.$refs["diceTwo"], 2.5, { x: vm.rand() }, "-=1.75")
        .to(vm.$refs["diceTwo"], 0.5, { y: 300 });

      let animationTlStopDice2 = new TimelineLite({
        delay: 5,
        onComplete: () => {
          this.$refs["animation-dice2"].style.animation = "stop";
          vm.toChangeAnimation(1, vm.dice1);
        }
      });

      vm.toChangeAnimation(2, vm.dice2);
    },
    diceThreeAnimation() {
      let vm = this;

      let animationTl4 = new TimelineLite({ delay: 1.5 });
      animationTl4
        .to(vm.$refs["diceThree"], 0.5, { y: -100 })
        .to(vm.$refs["diceThree"], 1.25, {
          y: 300,
          ease: Bounce.easeOut
        })
        .to(vm.$refs["diceThree"], 2.5, { x: vm.rand() }, "-=1.75")
        .to(vm.$refs["diceThree"], 0.5, { y: 370 }, "-=0.75")
        .to(vm.$refs["diceThree"], 0.5, { y: 150 })
        .to(vm.$refs["diceThree"], 1.25, {
          y: 320,
          ease: Bounce.easeOut
        })
        .to(vm.$refs["diceThree"], 2.5, { x: vm.rand() }, "-=1.75")
        .to(vm.$refs["diceThree"], 0.5, { y: 320 });

      let animationTlStopDice3 = new TimelineLite({
        delay: 5,
        onComplete: () => {
          this.$refs["animation-dice3"].style.animation = "stop";
          vm.toChangeAnimation(1, vm.dice1);
        }
      });

      vm.toChangeAnimation(3, vm.dice3);
    },
    toChangeAnimation(diceNum, face) {
      if (face == 1) {
        this.changeDiceResultToOne(diceNum);
      }
      if (face == 2) {
        this.changeDiceResultToTwo(diceNum);
      }
      if (face == 3) {
        this.changeDiceResultToThree(diceNum);
      }
      if (face == 4) {
        this.changeDiceResultToFour(diceNum);
      }
      if (face == 5) {
        this.changeDiceResultToFive(diceNum);
      }
      if (face == 6) {
        this.changeDiceResultToSix(diceNum);
      }
    },
    // ----------------- Dice 1 Positon -----------------
    changeDiceResultToOne(dice) {
      this.$refs["animation-dice-" + dice + "-face-1"].style.transform =
        "translateZ(calc(var(--face-size) / 2))";

      this.$refs["animation-dice-" + dice + "-face-2"].style.transform =
        "translateX(50%) rotateY(90deg)";

      this.$refs["animation-dice-" + dice + "-face-3"].style.transform =
        "translateX(-50%) rotateY(-90deg)";

      this.$refs["animation-dice-" + dice + "-face-4"].style.transform =
        "translateY(50%) rotateX(90deg)";

      this.$refs["animation-dice-" + dice + "-face-5"].style.transform =
        "translateY(-50%) rotateX(-90deg)";

      this.$refs["animation-dice-" + dice + "-face-6"].style.transform =
        "translateZ(calc(var(--face-size) / -2)) rotateY(180deg)";
    },
    // ----------------- Dice 2 Positon -----------------
    changeDiceResultToTwo(dice) {
      this.$refs["animation-dice-" + dice + "-face-2"].style.transform =
        "translateZ(calc(var(--face-size) / 2))";

      this.$refs["animation-dice-" + dice + "-face-3"].style.transform =
        "translateZ(calc(var(--face-size) / -2)) rotateY(180deg)";

      this.$refs["animation-dice-" + dice + "-face-4"].style.transform =
        "translateY(50%) rotateX(90deg)";

      this.$refs["animation-dice-" + dice + "-face-5"].style.transform =
        "translateY(-50%) rotateX(-90deg)";

      this.$refs["animation-dice-" + dice + "-face-6"].style.transform =
        "translateX(50%) rotateY(90deg)";

      this.$refs["animation-dice-" + dice + "-face-1"].style.transform =
        "translateX(-50%) rotateY(-90deg)";
    },
    // ----------------- Dice 3 Positon -----------------
    changeDiceResultToThree(dice) {
      this.$refs["animation-dice-" + dice + "-face-3"].style.transform =
        "translateZ(calc(var(--face-size) / 2))";

      this.$refs["animation-dice-" + dice + "-face-4"].style.transform =
        "translateY(50%) rotateX(90deg)";

      this.$refs["animation-dice-" + dice + "-face-5"].style.transform =
        "translateY(-50%) rotateX(-90deg)";

      this.$refs["animation-dice-" + dice + "-face-6"].style.transform =
        "translateX(-50%) rotateY(-90deg)";

      this.$refs["animation-dice-" + dice + "-face-1"].style.transform =
        "translateX(50%) rotateY(90deg)";

      this.$refs["animation-dice-" + dice + "-face-2"].style.transform =
        "translateZ(calc(var(--face-size) / -2)) rotateY(180deg)";
    },
    // ----------------- Dice 4 Positon -----------------
    changeDiceResultToFour(dice) {
      this.$refs["animation-dice-" + dice + "-face-4"].style.transform =
        "translateZ(calc(var(--face-size) / 2))";

      this.$refs["animation-dice-" + dice + "-face-5"].style.transform =
        "translateZ(calc(var(--face-size) / -2)) rotateY(180deg)";

      this.$refs["animation-dice-" + dice + "-face-6"].style.transform =
        "translateY(-50%) rotateX(-90deg)";

      this.$refs["animation-dice-" + dice + "-face-1"].style.transform =
        "translateY(50%) rotateX(90deg)";

      this.$refs["animation-dice-" + dice + "-face-2"].style.transform =
        "translateX(50%) rotateY(90deg)";

      this.$refs["animation-dice-" + dice + "-face-3"].style.transform =
        "translateX(-50%) rotateY(-90deg)";
    },
    // ----------------- Dice 5 Positon -----------------
    changeDiceResultToFive(dice) {
      this.$refs["animation-dice-" + dice + "-face-5"].style.transform =
        "translateZ(calc(var(--face-size) / 2))";

      this.$refs["animation-dice-" + dice + "-face-6"].style.transform =
        "translateY(-50%) rotateX(-90deg)";

      this.$refs["animation-dice-" + dice + "-face-1"].style.transform =
        "translateY(50%) rotateX(90deg)";

      this.$refs["animation-dice-" + dice + "-face-2"].style.transform =
        "translateX(50%) rotateY(90deg)";

      this.$refs["animation-dice-" + dice + "-face-3"].style.transform =
        "translateX(-50%) rotateY(-90deg)";

      this.$refs["animation-dice-" + dice + "-face-4"].style.transform =
        "translateZ(calc(var(--face-size) / -2)) rotateY(180deg)";
    },
    // ----------------- Dice 5 Positon -----------------
    changeDiceResultToSix(dice) {
      this.$refs["animation-dice-" + dice + "-face-6"].style.transform =
        "translateZ(calc(var(--face-size) / 2))";

      this.$refs["animation-dice-" + dice + "-face-1"].style.transform =
        "translateZ(calc(var(--face-size) / -2)) rotateY(180deg)";

      this.$refs["animation-dice-" + dice + "-face-2"].style.transform =
        "translateX(50%) rotateY(90deg)";

      this.$refs["animation-dice-" + dice + "-face-3"].style.transform =
        "translateX(-50%) rotateY(-90deg)";

      this.$refs["animation-dice-" + dice + "-face-4"].style.transform =
        "translateY(-50%) rotateX(-90deg)";

      this.$refs["animation-dice-" + dice + "-face-5"].style.transform =
        "translateY(50%) rotateX(90deg)";
    }
  },
  mounted() {
    EventBus.$emit("update-session-storage");
  }
};
</script>

<style lang="scss">
.animation-dice,
.animation-dice2,
.animation-dice3 {
  position: absolute;
  width: var(--face-size);
  height: var(--face-size);
  transform-style: preserve-3d;
}

@keyframes spin {
  from {
    transform: rotateX(0deg) rotateY(0deg);
  }
  to {
    transform: rotateX(360deg) rotateY(720deg);
  }
}

/* Position face 1 and dots */
.animation-dice-1-face-1,
.animation-dice-2-face-1,
.animation-dice-3-face-1 {
  transform: translateZ(calc(var(--face-size) / -2)) rotateY(180deg);
}
.animation-dice-1-face-1 > .dot,
.animation-dice-2-face-1 > .dot,
.animation-dice-3-face-1 > .dot {
  left: 50%;
  top: 50%;
}

/* Position face 2 and dots */
.animation-dice-1-face-2,
.animation-dice-2-face-2,
.animation-dice-3-face-2 {
  transform: translateX(50%) rotateY(90deg);
}
.animation-dice-1-face-2 > .dot:nth-child(1),
.animation-dice-2-face-2 > .dot:nth-child(1),
.animation-dice-3-face-2 > .dot:nth-child(1) {
  left: 25%;
  top: 50%;
}
.animation-dice-1-face-2 > .dot:nth-child(1),
.animation-dice-2-face-2 > .dot:nth-child(1),
.animation-dice-3-face-2 > .dot:nth-child(1) {
  left: 25%;
  top: 50%;
}
.animation-dice-1-face-2 > .dot:nth-child(2),
.animation-dice-2-face-2 > .dot:nth-child(2),
.animation-dice-3-face-2 > .dot:nth-child(2) {
  left: 75%;
  top: 50%;
}

/* Position face 3 and dots */
.animation-dice-1-face-3,
.animation-dice-2-face-3,
.animation-dice-3-face-3 {
  transform: translateX(-50%) rotateY(-90deg);
}
.animation-dice-1-face-3 > .dot:nth-child(1),
.animation-dice-2-face-3 > .dot:nth-child(1),
.animation-dice-3-face-3 > .dot:nth-child(1) {
  left: 25%;
  top: 25%;
}
.animation-dice-1-face-3 > .dot:nth-child(2),
.animation-dice-2-face-3 > .dot:nth-child(2),
.animation-dice-3-face-3 > .dot:nth-child(2) {
  left: 50%;
  top: 50%;
}
.animation-dice-1-face-3 > .dot:nth-child(3),
.animation-dice-2-face-3 > .dot:nth-child(3),
.animation-dice-3-face-3 > .dot:nth-child(3) {
  left: 75%;
  top: 75%;
}

/* Position face 4 and dots */
.animation-dice-1-face-4,
.animation-dice-2-face-4,
.animation-dice-3-face-4 {
  transform: translateY(50%) rotateX(90deg);
}
.animation-dice-1-face-4 > .dot:nth-child(1),
.animation-dice-2-face-4 > .dot:nth-child(1),
.animation-dice-3-face-4 > .dot:nth-child(1) {
  left: 25%;
  top: 25%;
}
.animation-dice-1-face-4 > .dot:nth-child(2),
.animation-dice-2-face-4 > .dot:nth-child(2),
.animation-dice-3-face-4 > .dot:nth-child(2) {
  left: 75%;
  top: 25%;
}
.animation-dice-1-face-4 > .dot:nth-child(3),
.animation-dice-2-face-4 > .dot:nth-child(3),
.animation-dice-3-face-4 > .dot:nth-child(3) {
  left: 25%;
  top: 75%;
}
.animation-dice-1-face-4 > .dot:nth-child(4),
.animation-dice-2-face-4 > .dot:nth-child(4),
.animation-dice-3-face-4 > .dot:nth-child(4) {
  left: 75%;
  top: 75%;
}

/* Position face 5 and dots */
.animation-dice-1-face-5,
.animation-dice-2-face-5,
.animation-dice-3-face-5 {
  transform: translateY(-50%) rotateX(-90deg);
}
.animation-dice-1-face-5 > .dot:nth-child(1),
.animation-dice-2-face-5 > .dot:nth-child(1),
.animation-dice-3-face-5 > .dot:nth-child(1) {
  left: 25%;
  top: 25%;
}
.animation-dice-1-face-5 > .dot:nth-child(2),
.animation-dice-2-face-5 > .dot:nth-child(2),
.animation-dice-3-face-5 > .dot:nth-child(2) {
  left: 75%;
  top: 25%;
}
.animation-dice-1-face-5 > .dot:nth-child(3),
.animation-dice-2-face-5 > .dot:nth-child(3),
.animation-dice-3-face-5 > .dot:nth-child(3) {
  left: 25%;
  top: 75%;
}
.animation-dice-1-face-5 > .dot:nth-child(4),
.animation-dice-2-face-5 > .dot:nth-child(4),
.animation-dice-3-face-5 > .dot:nth-child(4) {
  left: 75%;
  top: 75%;
}
.animation-dice-1-face-5 > .dot:nth-child(5),
.animation-dice-2-face-5 > .dot:nth-child(5),
.animation-dice-3-face-5 > .dot:nth-child(5) {
  left: 50%;
  top: 50%;
}

/* Position face 6 and dots */
.animation-dice-1-face-6,
.animation-dice-2-face-6,
.animation-dice-3-face-6 {
  transform: translateZ(calc(var(--face-size) / 2));
}
.animation-dice-1-face-6 > .dot:nth-child(1),
.animation-dice-2-face-6 > .dot:nth-child(1),
.animation-dice-3-face-6 > .dot:nth-child(1) {
  left: 25%;
  top: 25%;
}
.animation-dice-1-face-6 > .dot:nth-child(2),
.animation-dice-2-face-6 > .dot:nth-child(2),
.animation-dice-3-face-6 > .dot:nth-child(2) {
  left: 75%;
  top: 25%;
}
.animation-dice-1-face-6 > .dot:nth-child(3),
.animation-dice-2-face-6 > .dot:nth-child(3),
.animation-dice-3-face-6 > .dot:nth-child(3) {
  left: 25%;
  top: 50%;
}
.animation-dice-1-face-6 > .dot:nth-child(4),
.animation-dice-2-face-6 > .dot:nth-child(4),
.animation-dice-3-face-6 > .dot:nth-child(4) {
  left: 75%;
  top: 50%;
}
.animation-dice-1-face-6 > .dot:nth-child(5),
.animation-dice-2-face-6 > .dot:nth-child(5),
.animation-dice-3-face-6 > .dot:nth-child(5) {
  left: 25%;
  top: 75%;
}
.animation-dice-1-face-6 > .dot:nth-child(6),
.animation-dice-2-face-6 > .dot:nth-child(6),
.animation-dice-3-face-6 > .dot:nth-child(6) {
  left: 75%;
  top: 75%;
}

.dice-wrapper {
  width: 100%;
  text-align: left;
}
</style>

<style lang="scss" scoped>
#animation-dice-1,
#animation-dice-2,
#animation-dice-3 {
  // display: inline-block;
  position: relative;
  animation: spin 1s linear 2s infinite;
}

#perspective {
  position: absolute;
  // display: inline-block;
  top: -80px;
  left: 0;
}
.thai-hilo-game {
  position: relative;
  background: #212121;
  background-size: cover;
  background-position: top;
  height: 373px;
}

.thai-hilo-animation-section {
  display: none;
  position: absolute;
  top: -100px;
  left: 0;
  width: 100%;
  height: 125%;
  overflow: hidden;
  background: rgba(#000000, 0.9);
  z-index: 100;
}

.thai-hilo-animation-section.hide {
  display: none;
}

.thai-hilo-animation {
  text-align: center;
  width: 100%;
  height: 100%;
}

.thai-hilo-disallow-betting-section {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: white;
  background: rgba(#000000, 0.9);
  font-size: 16px;
  z-index: 100;
}

.thai-hilo-stop-animation-section {
  position: absolute;
  display: none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: white;
  background: rgba(#000000, 0.9);
  font-size: 16px;
}

.thai-hilo-stop-animation-section.show {
  display: block;
}

.thai-hilo-disallow-betting,
.thai-hilo-stop-animation {
  width: 100%;
  height: 100%;
}

.thai-hilo-animation-container {
  height: 100%;
  width: 100%;
  background: rgba(#000000, 0.9);
}

.thai-hilo-animation-result {
  display: none;
  width: 100%;
  height: 100%;
}

.thai-hilo-animation-result .thai-hilo-animation-result-plate {
  width: 100%;
  height: auto;
  z-index: 99;
}

.thai-hilo-animation-result-container,
.thai-hilo-animation-banner-container {
  position: relative;
}

.thai-hilo-animation-result-container {
  z-index: 2;
}

.thai-hilo-animation-banner-container {
  display: none;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding: 0 20px;
  z-index: 1;
}

.thai-hilo-animation-result-dice {
  display: none;
  width: 15%;
  position: absolute;
  top: 0;
  z-index: 100;
  border-radius: 6px;
  box-shadow: 0 0 4px 2px #00000044;
}

.thai-hilo-animation-result-banner-top,
.thai-hilo-animation-result-banner-sum {
  width: 85%;
  position: absolute;
  top: 25%;
}

.thai-hilo-animation-result-banner-sum {
  top: 27%;
}

.thai-hilo-animation-result-banner-sum-total {
  font-size: 24px;
  color: $tai-xiu-theme-color-6;
  font-weight: bold;
  font-size: 36px;
  line-height: 1;
}

.thai-hilo-animation-result-banner-sum-title {
  color: white;
  font-weight: bold;
}

.thai-hilo-animation-result-banner-bottom,
.thai-hilo-animation-result-banner-game {
  width: 85%;
  position: absolute;
  bottom: 25%;
}

.thai-hilo-animation-result-banner-game {
  bottom: 30%;
}

.thai-hilo-animation-result-banner-game-result {
  padding: 5px;
  background-color: white;
  color: $tai-xiu-theme-color-3;
  font-weight: bold;
  width: 60px;
  margin: 0 5px;
  border-radius: 8px;
  text-align: center;
}

.thai-hilo-game-animation-next-draw {
  background-color: $tai-xiu-theme-color-13;
  color: $tai-xiu-theme-color-5;
  border-radius: 6px;
  font-size: 14px;
  margin-right: 5px;
  padding: 4px 20px;
  font-weight: bolder;
  z-index: 1;
}

.thai-hilo-game-animation-next-draw-section {
  position: absolute;
  top: 20px;
  width: 100%;
}

.thai-hilo-animation-inner {
  position: relative;
  width: 100%;
}

.thai-hilo-animation-banner-inner {
  height: 100%;
}

.thai-hilo-disallow-betting-section {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: white;
  background: rgba(#000000, 0.9);
  font-size: 16px;
}

.thai-hilo-disallow-betting,
.thai-hilo-stop-animation {
  width: 100%;
  height: 100%;
}

@media only screen and (max-width: 360px) {
  .thai-hilo-animation-result-banner-sum {
    top: 26%;
  }

  .thai-hilo-animation-result-banner-game {
    bottom: 29%;
  }
}
</style>
